<template>
  <div class="checkbox" @click="update">
    <dean-icon
      v-if="checked"
      class="checked"
      :glyph="checkboxCheckedIcon"
      :width="width"
    >
    </dean-icon>
    <dean-icon
      v-else
      class="unchecked"
      :glyph="checkboxUncheckedIcon"
      :width="width"
    >
    </dean-icon>
  </div>
</template>

<script lang="ts">
// VUE
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

// SVG
import checkboxCheckedIcon from "../svg/feather-icons/check-square.svg";
import checkboxUncheckedIcon from "../svg/icons/check-square-unchecked.svg";

import deanIcon from "./deanIcon.vue";

@Component({
  components: {
    deanIcon,
    checkboxCheckedIcon,
    checkboxUncheckedIcon,
  },
})
export default class deanCheckbox extends Vue {
  // DATA
  public checkboxCheckedIcon: object = checkboxCheckedIcon;
  public checkboxUncheckedIcon: object = checkboxUncheckedIcon;

  public checked: boolean = false;
  public uuid: string = "";

  @Prop({ default: "" }) private id!: string;
  @Prop({ default: false }) private value!: boolean;
  @Prop({ default: null }) private data!: object;
  @Prop({ default: 25 }) private width!: number;

  //METHODS
  @Watch("value")
  valueChanged() {
    this.checked = this.value;
  }

  public update(data: any) {
    this.checked = !this.checked;
    this.$emit("update", { value: this.checked, id: this.id, data: this.data });
  }

  public mounted() {
    this.valueChanged();
  }
}
</script>
<style scoped>
.checkbox {
  cursor: pointer;
}
.unchecked {
  fill: var(--color-dark-shade-4, $color-dark-shade-4);
}
.checked {
  fill: var(--color-link, $color-link);
}
</style>
